<template>
  <div class="d-flex flex-row flex-wrap pa-2">
    <div class="col-12" v-if="isDownloadError" ref="downloadError">
      <v-alert
        dense
        text
        type="error"
        icon="mdi-alert-circle"
        class="ma-0 flex-grow-1 rounded-lg"
      >
        <span class="black--text">
          <strong>Sorry! </strong> Document could not be downloaded at this
          time.
        </span>
      </v-alert>
    </div>

    <div class="col-12 text-center">
      <BaseButton
        text="DOWNLOAD ALL"
        width="300"
        height="60"
        icon="mdi-folder-zip"
        depressed
        rounded
        :color="this.isDownloadedAll ? 'btn-file-downloaded-text' : 'psorange'"
        class="font-weight-bold flex-grow-0"
        className="btn-file-downloaded"
        :textColor="
          this.isDownloadedAll ||
          (this.isDownloadedAll && this.isDownloadingAll)
            ? 'white--text'
            : ''
        "
        :iconColor="
          this.isDownloadedAll ||
          (this.isDownloadedAll && this.isDownloadingAll)
            ? 'white'
            : ''
        "
        :fontSize="$vuetify.breakpoint.mdAndUp ? 'font-20' : 'font-18'"
        @click="downloadAllFiles(data.files, quoteReference)"
        :loading="this.isDownloadingAll"
        loadingText="DOWNLOADING..."
        :loadingIconColor="
          this.isDownloadedAll && this.isDownloadingAll ? 'white' : ''
        "
      />
    </div>

    <div v-for="file in data.files" class="col-12 col-lg-6" :key="file.id">
      <div
        class="rounded-lg pa-6 mb-5 d-flex flex-column doc"
        :class="[file.isDownloaded ? 'bg-blue-grey-500' : 'bg-blue-grey-900']"
      >
        <div class="d-flex justify-end">
          <div style="position: relative">
            <v-icon
              v-if="!file.isDownloaded"
              color="red"
              style="position: absolute; z-index: 100; font-size: 12px"
              >mdi-circle</v-icon
            >
            <v-icon color="white">mdi-file mdi-24px</v-icon>
          </div>
        </div>
        <h5 class="font-24 font-weight-medium white--text mt-4">
          {{ file.Name }}
        </h5>
        <p class="white--text mt-4 flex-grow-1">PDF</p>
        <BaseButton
          text="DOWNLOAD"
          height="60"
          depressed
          rounded
          block
          :color="file.isDownloaded ? 'btn-file-downloaded-text' : 'psorange'"
          class="font-weight-bold flex-grow-0"
          className="btn-file-downloaded"
          :textColor="
            file.isDownloaded || (file.isDownloaded && file.isDownloading)
              ? 'white--text'
              : ''
          "
          :fontSize="$vuetify.breakpoint.mdAndUp ? 'font-20' : 'font-18'"
          @click="downloadFile(file)"
          :loading="file.isDownloading"
          loadingText="DOWNLOADING..."
          :loadingIconColor="
            file.isDownloaded && file.isDownloading ? 'white' : ''
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import documentService from "@/services/document.service";

export default {
  props: {
    data: [Array, Object],
  },
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
  data() {
    return {
      isDownloadError: false,
      isDownloadedAll: false,
      isDownloadingAll: false,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "httpConfig",
      "httpConfigAsRqs",
      "quoteReference",
    ]),
  },
  watch: {
    data() {
      this.isDownloadError = false;
      this.isDownloadedAll = false;
      this.isDownloadingAll = false;
    },
  },
  methods: {
    downloadFile(file) {
      this.isDownloadError = false;
      if (file.isDownloading) return;
      file.isDownloading = true;

      documentService
        .getDocument(file.Link, this.httpConfig)
        .then((res) => {
          window.open(URL.createObjectURL(res));
          file.isDownloading = false;
          file.isDownloaded = true;
        })
        .catch((error) => {
          file.isDownloading = false;
          file.isDownloaded = false;
          this.isDownloadError = true;
          setTimeout(() => {
            const el = this.$refs.downloadError;
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }, 500);
          console.error(error);
        });
    },
    downloadAllFiles(allFiles, quoteReference) {
      this.isDownloadError = false;
      if (this.isDownloadingAll) return;
      this.isDownloadingAll = true;

      // AllDocuments is an RqsOnly endpoint
      documentService
        .getAllDocuments(allFiles, this.httpConfigAsRqs)
        .then((res) => {
          const href = URL.createObjectURL(res);
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          const filename = quoteReference + ".zip";
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          this.isDownloadingAll = false;
          this.isDownloadedAll = true;
        })
        .catch((error) => {
          this.isDownloadingAll = false;
          this.isDownloadedAll = false;
          this.isDownloadError = true;
          setTimeout(() => {
            const el = this.$refs.downloadError;
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }, 500);
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}

tr:nth-of-type(odd) {
  background-color: #f5f5f5 !important;
}

.btn-file-downloaded {
  border: 1px solid white;
}

.btn-file-downloaded-text {
  background-color: $blue-grey-500 !important;
}

.doc {
  height: 330px;
}
h5.font-24 {
  line-height: 32px;
}
</style>
